<div [formGroup]="formularz">
    <label class="c-label">
      <span class="c-label__title" [class.text-danger]="formularz?.get('rodzajPowierzchni')?.errors && formularz?.get('rodzajPowierzchni')?.touched">Rodzaj powierzchni</span>
        <shared-select id='rodzajPowierzchni' formControlName="rodzajPowierzchni"
                       (click)="formularz?.get('rodzajPowierzchni').markAsTouched()"
                       [domyslnyWiersz]="'wybierz'"
                       [list]="konwertujRodzajePowierzchni(rodzajePowierzchni)"
        ></shared-select>
      <span *ngIf="formularz?.get('rodzajPowierzchni')?.errors && formularz?.get('rodzajPowierzchni')?.touched"
            class="c-label__title text-danger u-margin-right-tiny">Ta informacja jest obowiązkowa</span>
    </label>
</div>
